import { Validator } from '@portal/kit/pkg/services'

const userEmailValidator = values => {
  const rules = {
    email: ['isRequired', 'isEmail'],
    email_confirmation: ['isRequired', 'isEmail', ['isEqualTo', { field: 'email' }]]
  }

  return new Validator(values, rules).getErrors()
}

export default userEmailValidator
